import React, { useCallback, useEffect, useState } from "react";
import LandscapeProgramLayout from "../LandscapeProgramLayout";
import cn from "../../../utils/cn";
import BottomNav from "../BottomNav";
import { useAuthContext } from "../../../context/auth";
import useCountDown from "../../../hooks/useCountDown";
import CircularProgress from "../../CircularProgress";
import useShowClassRanking from "../../../hooks/useShowClassRanking";

function CoolDown() {
  const { circuitProgram, weightProgram, hiluxProgram, sendSetStep, step: pageStep } =
    useAuthContext();
  const program = hiluxProgram ?? circuitProgram ?? weightProgram;
  // 쿨다운이 끝나면 '오늘의 TOP 5' 가 있으면 그리로, 없으면 지금처럼 첫 화면으로.
  const showClassRanking = useShowClassRanking();

  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [step, setStep] = useState(0);
  const { count, start, reset } = useCountDown(
    40,
    useCallback(() => {
      setStep((prev) => {
        if (program?.coolDownMovements.length === prev + 1) {
          sendSetStep(showClassRanking ? pageStep + 1 : 0);
          return 0;
        }
        return prev + 1;
      });
    }, [program, sendSetStep, showClassRanking, pageStep]),
    true
  );

  // Initial mount: start immediately
  useEffect(() => {
    start();
    videoRef.current?.play();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // When step changes (new movement), reset and restart timer
  useEffect(() => {
    if (step === 0) return; // Skip on initial mount
    reset();
    start();
    videoRef.current?.play();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  if (!program) return <></>;
  const nowCoolDown = program.coolDownMovements[step];

  return (
    <LandscapeProgramLayout step={6}>
      <div className="flex h-full">
        <div className="min-w-[364px] h-full">
          <p className="gradient-text uppercase italic text-[32px] font-bold mt-[70px] ml-[50px]">
            STEP
          </p>
          <div className="flex flex-col w-full pl-[30px] gap-2 mt-[68px]">
            {program.coolDownMovements.map((movement, index) => (
              <div
                className={cn(
                  "rounded-l-xl px-12 py-4 text-[32px] text-[#48505F] whitespace-nowrap",
                  index === step && "bg-white text-black"
                )}
                key={index}
              >
                {index + 1}. {movement.movement?.name}
              </div>
            ))}
          </div>
        </div>
        <div className="flex-1 bg-white h-full relative">
          <video
            className="w-full h-full object-cover"
            ref={videoRef}
            loop
            muted
            key={nowCoolDown.movement?.video}
          >
            <source src={nowCoolDown.movement?.video} type="video/mp4" />
          </video>
          <div className="absolute bottom-10 right-10 w-[310px] h-[310px]">
            <CircularProgress maxValue={40} value={count} />
          </div>
        </div>
      </div>
      <BottomNav />
    </LandscapeProgramLayout>
  );
}

export default CoolDown;
